module.exports = __webpack_public_path__ + "img/voice_202307_03.bcc04c27.jpg";